import { createStore, applyMiddleware, combineReducers, compose } from 'redux'
import { thunk } from 'redux-thunk'

import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import page from './reducers/page'
import limit from './reducers/limit'
import selectedUser from './reducers/selectedUser'
import cart from './reducers/cart'
import loader from './reducers/loader'
import cartId from './reducers/cartId'

import moduleSlice from './slice/module-slice'
import allFeaturesSlice from './slice/all-features-slice'
import allPermissionsSlice from './slice/all-permissions-slice'
import allRoleSlice from './slice/all-role-slice'
import staffScheduleSlice from './slice/staff-schedule-slice'
import splitPaymentReducer from './slice/splitPaymentSlice'

import menuManagementReducer from './reducers/menuManagementReducer'
import essentialMenuReducer from './reducers/essential-menuReducer'
import settingReducer from './reducers/setting-reducer'
import utilityReducer from './reducers/utilitReducer'
import onlineOrderReducer from './reducers/onlineOrderReducer'
import loyaltyReducer from './reducers/loyaltyReducer'
import staffManagementReducer from './reducers/staffManagementReducer'
import takeOrderReducer from './reducers/takeOrder'
import reservationReducer from './reducers/reservation-Reducer'
import tableReducer from './reducers/table'
import customerReducer from './reducers/customerReducer'
import CourseWisePay from './slice/take-order-slice/course-wise-pay'
import discount from './slice/take-order-slice/discount-slice'
import cbdReducer from './reducers/cbdReducer'

import costManagementReducer from './slice/cost-management/cost-management-slice'
import orderHistoryReducer from './reducers/orderHistoryReducer'
import dashboardReducer from './slice/dashboard/dashboard-slice'

const rootReducer = combineReducers({
  modules: moduleSlice,
  allFeatures: allFeaturesSlice,
  allPermissions: allPermissionsSlice,
  allRoles: allRoleSlice,
  staffShift: staffScheduleSlice,
  menuManage: menuManagementReducer,
  essentialMenu: essentialMenuReducer,
  staffManage: staffManagementReducer,
  utility: utilityReducer,
  reservation: reservationReducer,
  settings: settingReducer,
  cbd: cbdReducer,
  page,
  limit,
  selectedUser,
  cart,
  loader,
  cartId,
  onlineOrdering: onlineOrderReducer,
  loyalty: loyaltyReducer,
  customer: customerReducer,
  table: tableReducer,
  takeOrder: takeOrderReducer,
  splitPayment: splitPaymentReducer,
  CourseWisePay: CourseWisePay,
  discount: discount,
  costManagement: costManagementReducer,
  orderHistory: orderHistoryReducer,
  dashboard: dashboardReducer
})

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['modules']
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(thunk))
)

const persistor = persistStore(store)

export { store, persistor }
